/*
 * Copyright (c) 2018-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const CLIENT_ID = process.env.REACT_APP_OAUTH2_CLIENT_ID || '';
const ISSUER = process.env.REACT_APP_ISSUER || 'https://guidewire-hub.oktapreview.com/oauth2/ausj9ftnbxOqfGU4U0h7';
const OKTA_TESTING_DISABLEHTTPSCHECK = process.env.REACT_APP_OKTA_TESTING_DISABLEHTTPSCHECK || false;
const BASENAME = process.env.PUBLIC_URL || '';
const REDIRECT_URI = process.env.REACT_APP_OAUTH2_REDIRECT_URI || `${window.location.origin}${BASENAME}/auth/callback`;
const IN_SCOPE = process.env.REACT_APP_IN_SCOPE || '';
const DEFAULT_DOMAIN = process.env.REACT_APP_DEFAULT_DOMAIN || '';
const USERNAME_MAPPING = process.env.REACT_APP_USERNAME_MAPPING || '';

export default {
  oidc: {
    clientId: CLIENT_ID,
    issuer: ISSUER,
    redirectUri: REDIRECT_URI,
    // openid is needed to retrieve code
    // scp.newalmaden.dev.in-app.api is owned by newalmaden.dev.in-app, the owner needs to give this keti client the scope so this client can access it
    scopes: ['openid', 'profile', 'groups', 'tenant_id', `${IN_SCOPE}`],
    pkce: true,
    disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
  },
  app: {
    basename: BASENAME,
    defaultDomain: `${DEFAULT_DOMAIN}`,
    usernameMapping: `${USERNAME_MAPPING}`,
  },
};
